// TODO: OR maybe Renaming to notificationTopic Discussion for Constants to be ALL UPPER
export const notificationTopic = {
  saveWorkCenterDetails: 'saveWorkCenterDetails',
  saveSetupParameterDetails: 'saveSetupParameterDetails'
};
